import { Injectable } from '@angular/core';
import { EntityStateStore } from '@shared/store/entity-state-store';
import { PresentUserData } from '@/app/platform/platform-data/models/present-user-data';
import { PresentDeviceUserFilters } from '@/app/platform/platform-data/services/types';

export interface PresentDeviceUserExtraState {
  filters: PresentDeviceUserFilters;
}

@Injectable({ providedIn: 'root' })
export class PresentDeviceUserStore extends EntityStateStore<PresentUserData, PresentDeviceUserExtraState> {
  constructor() {
    super(() => ({ filters: {} }));
  }
}
